import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import * as moment from 'moment'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { ONE_SECOND } from '../../../../../constants/DueTime'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { AtylTable } from '../../../../atyl-input-components/atyl-input-components'
import { FormAtylBase } from '../../../../form-atyl-base'
import { FormAtylControlService } from '../../../../form-atyl-control.service'
import { FormAtylService } from '../../../../form-atyl.service'
import { AtylService } from '../../../../service/atyl.service'

@Component({
	selector: 'atyl-form-input-agrement',
	templateUrl: './form-input-agrement.component.html',
	styleUrls: ['./form-input-agrement.component.scss']
})
export class FormInputAgrementComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>()
	label: string
	errorString: string
	listAtylTableAgrement: any = [];
	private _listValuesTableAgrement: any = [];
	set listValuesTableAgrement(listValuesTableAgrement: any[]) {
		this._listValuesTableAgrement = listValuesTableAgrement
	}
	get listValuesTableAgrement() {
		return this._listValuesTableAgrement
	}
	listTableAgrement: any = [];
	listAgrements: any = [];
	tableAgrement: FormGroup
	listMAM: any = [];
	loading: boolean = false;
	selectedAgrement: any
	tempSelectedMAM: any
	private debounceAgreMAM: Subject<string> = new Subject()



	constructor(
		private readonly atylFormService: FormAtylService,
		private readonly atylControlerService: FormAtylControlService,
		private readonly atylService: AtylService,
		private readonly cdr: ChangeDetectorRef,
		private readonly inputLabelPipe: InputLabelPipe
	) {

	}

	ngOnInit(): void {
		this.initSearch()
		if (this.forminput) {
			if (this.forminput.optionsDefault.flat) {
				let tempStructAgreInput = new Object
				this.forminput.optionsDefault.addButton.forEach((value: any, index: number) => {
					let group = {}
					let calcMinRow = 0
					group[1000] = new FormArray([])
					if (this.forminput.options && Array.isArray(this.forminput.options) && this.forminput.options[0].type === 'label') {
						calcMinRow = this.forminput.options[0].options.values.length
					}
					let atylTableObj = new AtylTable({
						ID: 1000,
						key: 'TABLE',
						label: '',
						options: this.forminput.options,
						value: '',
						restrictions: [],
						order: 0,
						customBehaviour: '',
						type: 'table',
						minRow: calcMinRow
					})
					if (index > 0) {
						this.listAtylTableAgrement.push(this.atylFormService.GeneratedTable(atylTableObj))
					}
					else {
						this.listValuesTableAgrement = Array(this.forminput.optionsDefault.addButton.length).fill(null).map((x, y) => new Object)
						this.listAtylTableAgrement = [this.atylFormService.GeneratedTable(atylTableObj)]
					}

					if (this.forminput.value && this.forminput.value[value.key]) {
						if (tempStructAgreInput[value.key] !== undefined) {
							tempStructAgreInput[value.key]++
						}
						else {
							tempStructAgreInput[value.key] = 0
						}
						this.listValuesTableAgrement[index] = this.forminput.value[value.key][tempStructAgreInput[value.key]] ? this.forminput.value[value.key][tempStructAgreInput[value.key]] : new Object
					}
					this.listValuesTableAgrement[index].key = value.key
					if (this.listValuesTableAgrement[index].datestart && this.listValuesTableAgrement[index].datestart.lastIndexOf('/') !== -1)
						this.listValuesTableAgrement[index].datestart = moment(this.listValuesTableAgrement[index].datestart, 'DD/MM/YYYY')
					if (this.listValuesTableAgrement[index].datefin && this.listValuesTableAgrement[index].datefin.lastIndexOf('/') !== -1)
						this.listValuesTableAgrement[index].datefin = moment(this.listValuesTableAgrement[index].datefin, 'DD/MM/YYYY')
					if (this.listAtylTableAgrement[index].rows && this.listAtylTableAgrement[index].rows.length > 0) {
						this.listAtylTableAgrement[index].rows.forEach((row, indexRow) => {
							this.listAtylTableAgrement[index].rowControlers.push(this.atylControlerService.generateControlersTable(row, this.forminput.value && this.forminput.value[value.key] && this.forminput.value[value.key][tempStructAgreInput[value.key]] ? this.forminput.value[value.key][tempStructAgreInput[value.key]].table[1000][indexRow] : null))
						})
					}
					if (value.key === 'MAM' && this.listValuesTableAgrement[index].key === 'MAM' && this.listValuesTableAgrement[index].MAM) {
						this.loading = true
						this.listValuesTableAgrement[index].MAMLabel = ''
						this.atylService.getTierByID(this.listValuesTableAgrement[index].MAM).subscribe((res: JSONRpcResponse) => {
							this.listValuesTableAgrement[index].MAMLabel = res.result.NOM
							this.loading = false
							this.cdr.detectChanges()
						})
					}
					else if (value.key === 'MAM' && this.listValuesTableAgrement[index].key === 'MAM') {
						this.listValuesTableAgrement[index].MAMLabel = ''
					}

					this.listAtylTableAgrement[index].rowControlers.forEach((rowControler: any) => {
						if (this.group.status === 'DISABLED') {
							rowControler.disable()
						}
						(group[1000] as FormArray).push(rowControler as FormGroup)
					})
					this.listValuesTableAgrement[index].table = this.listAtylTableAgrement[index]
					this.listTableAgrement.push(new FormGroup(group))
					this.group.get(this.forminput.ID).patchValue(this.forminput.value)
					this.changeFormAgrement()
					this.cdr.detectChanges()
				})
			}
			else {
				let group = {}
				let calcMinRow = 0
				group[1000] = new FormArray([])
				if (this.forminput.options && this.forminput.options[0].type === 'label') {
					calcMinRow = this.forminput.options[0].options.values.length
				}
				this.forminput.options = this.atylFormService.GeneratedTable(
					new AtylTable({
						ID: 1000,
						key: 'TABLE',
						label: '',
						options: this.forminput.options,
						value: '',
						restrictions: [],
						order: 0,
						customBehaviour: '',
						type: 'table',
						minRow: calcMinRow
					}))
				if (this.forminput.options.rows && this.forminput.options.rows.length > 0) {
					this.forminput.options.rows.forEach((row, index) => {
						this.forminput.options.rowControlers.push(this.atylControlerService.generateControlersTable(row, this.forminput.options.value ? this.forminput.value[index].table : null))
					})
				}
				this.forminput.options.rowControlers.forEach((rowControler, index) => {
					(group[1000] as FormArray).push(rowControler as FormGroup)
				})
				this.atylService.dossier.subscribe((dossierID) => {
					this.listAgrements = this.forminput.value
					if (this.listAgrements && Object.keys(this.listAgrements).length > 0) {
						Object.getOwnPropertyNames(this.listAgrements).forEach((agreType) => {
							if (agreType === 'MAM') {
								this.listAgrements[agreType].forEach((agre, index) => {
									this.atylService.getTierByID(agre.MAM).subscribe((res: JSONRpcResponse) => {
										this.listAgrements[agreType][index].MAMLabel = res.result.NOM
									})
								})
							}
						})
					}
					this.tableAgrement = new FormGroup(group)
					this.group.get(this.forminput.ID).patchValue(this.forminput.value)
					this.cdr.detectChanges()
				})

			}
		}
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	changeFormAgrement() {
		this.listAgrements = {}
		this.listValuesTableAgrement.forEach((agrem, index) => {
			if (agrem.key) {
				let toAdd = {
					id: agrem.key,
					type: agrem.key,
					datestart: agrem.datestart ? agrem.datestart : '',
					datefin: agrem.datefin ? agrem.datefin : '',
					places: agrem.places ? agrem.places : '',
					MAM: agrem.MAM ? agrem.MAM : '',
					MAMLabel: '',
					table: { ...this.listTableAgrement[index] },
					labelAgrement: ''
				}
				this.listMAM.forEach((MAM) => {
					if (MAM.key === toAdd.MAM)
						toAdd.MAMLabel = MAM.value
				})
				this.forminput.optionsDefault.addButton.forEach((element) => {
					if (element.key === agrem.key) {
						toAdd.labelAgrement = element.label
					}
				})
				let foundType = false
				if (this.listAgrements) {
					Object.keys(this.listAgrements).forEach((element) => {
						if (element === toAdd.type) {
							this.listAgrements[element].push(toAdd)
							foundType = true
						}
					})
				}
				else {
					this.listAgrements = {}
				}
				if (!foundType) {
					this.listAgrements[toAdd.type] = [toAdd]
				}
				let toValue = { ...this.listAgrements }
				Object.keys(toValue).forEach((agreType, agreTypeIndex) => {
					toValue[agreType] = [...toValue[agreType]]
					toValue[agreType].forEach((agre, agreIndex) => {
						let agreTemp = {
							id: agre.id,
							type: agre.type,
							datestart: agre.datestart,
							datefin: agre.datefin,
							places: agre.places,
							MAM: agre.MAM,
							table: { ...agre.table },
							labelAgrement: agre.labelAgrement
						}
						agreTemp.table = agreTemp.table.value ? agreTemp.table.value : agreTemp.table
						toValue[agreType][agreIndex] = agreTemp
					})
				})

				this.group.get(this.forminput.ID).setValue(toValue)
			}
		})
	}
	selectAgrement(key: any, label: any) {
		let toAdd = {
			id: key,
			type: key,
			label: label
		}
		this.selectedAgrement = toAdd
	}
	addDateEnd(datestart: any, datefin: any) {
		if (this.forminput.optionsDefault && this.forminput.optionsDefault.dateend) {
			datefin.value = moment(datestart.value, 'DD/MM/YYYY').add(this.forminput.optionsDefault.dateend, 'y').subtract(1, 'days').format('L')
			if (datefin.value === 'Invalid date') {
				datefin.value = ''
			}
			this.cdr.detectChanges()
		}

	}
	addDateEndFlat(datestart: any, datefin: any, indexTable: any, event?: any) {
		if (this.forminput.optionsDefault && this.forminput.optionsDefault.dateend) {
			datefin.value = moment(datestart.value, 'DD/MM/YYYY').add(this.forminput.optionsDefault.dateend, 'y').subtract(1, 'days').format('L')
			this.listValuesTableAgrement[indexTable].datefin = moment(datefin.value, 'DD/MM/YYYY')
			this.cdr.detectChanges()
		}
	}
	addAgrement(key: any, controlParentId: any, datestart: any, datefin: any, places?: any, MAM?: any) {
		let toAdd = {
			id: key,
			type: key,
			datestart: datestart.value,
			datefin: datefin.value,
			places: places ? places.value : '',
			MAM: this.tempSelectedMAM ? this.tempSelectedMAM.value : '',
			MAMLabel: '',
			table: { ...this.tableAgrement },
			labelAgrement: ''
		}
		this.listMAM.forEach((MAM: any) => {
			if (MAM.key === toAdd.MAM) {
				toAdd.MAMLabel = MAM.value
			}
		})
		this.forminput.optionsDefault.addButton.forEach((element) => {
			if (element.key === key) {
				toAdd.labelAgrement = element.label
			}
		})
		let foundType = false
		if (this.listAgrements) {
			Object.keys(this.listAgrements).forEach((element, index) => {
				if (element === toAdd.type) {
					this.listAgrements[element].push(toAdd)
					foundType = true
				}
			})
		}
		else {
			this.listAgrements = {}
		}
		if (!foundType) {
			this.listAgrements[toAdd.type] = [toAdd]
		}
		let toValue = { ...this.listAgrements }
		Object.keys(toValue).forEach((agreType, agreTypeIndex) => {
			toValue[agreType] = [...toValue[agreType]]
			toValue[agreType].forEach((agre, agreIndex) => {
				let agreTemp = {
					id: agre.id,
					type: agre.type,
					datestart: agre.datestart,
					datefin: agre.datefin,
					places: agre.places,
					MAM: agre.MAM,
					table: { ...agre.table },
					labelAgrement: agre.labelAgrement
				}
				agreTemp.table = agreTemp.table.value ? agreTemp.table.value : agreTemp.table
				toValue[agreType][agreIndex] = agreTemp
			})
		})

		this.group.get(this.forminput.ID).patchValue(toValue)
		this.selectedAgrement = null
	}
	triggerAutocompMAMList(search: any) {
		this.debounceAgreMAM.next(search)
	}
	initSearch() {
		this.debounceAgreMAM.pipe(
			debounceTime(ONE_SECOND)
		).subscribe(search => {
			if (search.length > 0) {
				this.loading = true
				this.atylService.getListeTierSelection(search).subscribe((result: JSONRpcResponse) => {
					let autoList = []
					for (let data of result.result) {
						autoList.push({
							key: data.ID,
							value: data.NOM
						})
					}
					this.listMAM = autoList
					this.loading = false
					this.cdr.detectChanges()
				})
			}
			else {
				let autoList = []
				autoList.push({
					key: '',
					value: ''
				})
				this.listMAM = autoList
				this.cdr.detectChanges()
			}

		})
	}
	displayAutoMAMList(key?: any): string | undefined {

		let selected: any
		if (this.listMAM) {
			this.listMAM.forEach((select: any) => {
				if (select.key === key) {
					selected = select
				}
			})
		}
		return selected ? selected.value : undefined
	}
	removeAgrement(indextype: any, index: any) {
		this.listAgrements[indextype].splice(index, 1)
		if (this.listAgrements[indextype].length === 0) {
			delete this.listAgrements[indextype]
		}
		let toValue = { ...this.listAgrements }
		toValue[indextype][index].table = toValue[indextype][index].table.value ? toValue[indextype][index].table.value : toValue[indextype][index].table
		this.group.get(this.forminput.ID).patchValue(this.listAgrements)
	}
	applyDateStartOnBlur(date: any, indexTable: any) {
		this.listValuesTableAgrement[indexTable].datestart = moment(date.value, 'DD/MM/YYYY')
	}
	applyDateFinOnBlur(date: any, indexTable: any) {
		this.listValuesTableAgrement[indexTable].datefin = moment(date.value, 'DD/MM/YYYY')
	}
	getNameMAMByID(agrement) {
		if (agrement.MAM) {
			/*this.atylService.getTierByID(agrement.MAM).subscribe((res) => {
			  return res.result.nom;
			});*/
		}
		else {
			return ''
		}
	}
}
